import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ShopProvider } from "./context/ShopContext";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Categories from "./pages/Categories";
import CategoryDetail from "./pages/CategoryDetail";
import ProductDetail from "./pages/ProductDetail";
import Orders from "./pages/Orders";
import Admin from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";
import CartDrawer from "./components/CartDrawer";
import Modals from "./components/Modals";
import ChatWidget from "./components/ChatWidget";
import ScrollToTop from "./components/ScrollToTop";

function AppRouter() {
  const location = useLocation();
  // Process Emergent OAuth redirect first (session_id in URL fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/category/:slug" element={<CategoryDetail />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/offers" element={<CategoryDetail offers />} />
      </Routes>
      <CartDrawer />
      <Modals />
      <ChatWidget />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <ShopProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </ShopProvider>
    </AuthProvider>
  );
}

export default App;
